import { Sort } from './sort';
/**
 * Sort domain of x scale of mark groups by groups.
 */
export const SortY = (options = {}) => {
    return Sort(Object.assign(Object.assign({}, options), { channel: 'y' }));
};
SortY.props = {};
//# sourceMappingURL=sortY.js.map